<template>
    <div class="dealWithBox">
        <div class="detailedInformation">
            <div class="deatlisName">
                <h4>合同详情</h4>
                <p style="border: 1px solid rgb(59, 99, 246);"></p>
            </div>
            <div class="deatlisContent">
                <div class="caseStatusBox">
                    <div class="caseStatus">
                        <p>合同名称:</p>
                        <span>{{caseContent.doc_title}}</span>
                    </div>
                    <div class="caseNo">
                        <p>合同编号:</p>
                        <span>{{caseContent.contract_sn}}</span>
                    </div>
                    <div class="registerTime">
                        <p>发起方:</p>
                        <span>{{caseContent.faqi_fang}}</span>
                    </div>
                </div>
                <div class="reasonBox">
                    <div class="reason">
                        <p>发起时间:</p>
                        <span>{{caseContent.create_time}}</span>
                    </div>
                    <div class="contractType">
                        <p>截止时间:</p>
                        <span>{{caseContent.expire_time}}</span>
                    </div>
                    <div class="money">
                        <p>合同状态:</p>
                        <span style="color: red">{{caseContent.status_desc}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--            证据清单列表-->
        <div>
            <div class="deatlisName">
                <h4>合同签署方</h4>
                <p style="border: 1px solid rgb(59, 99, 246);"></p>
            </div>
                            <el-button class="customize" @click="downloadEvidence">查看合同文件</el-button>
            <div style="margin-bottom: 30px">
                <avue-crud :data="data" :option="option">
                    <template slot-scope="scope" slot="menu">
                        <el-button  class="View" @click="signBtn(scope.row)" v-loading.fullscreen.lock="fullscreenLoading" v-if="scope.row.is_show_sign==1">签署</el-button>
                        <el-button  class="View" @click="urgeBtn(scope.row)" v-loading.fullscreen.lock="fullscreenLoading" v-if="scope.row.cui_qian==1">催办</el-button>
                    </template>
                </avue-crud>
            </div>
        </div>
    </div>
</template>

<script>

import { contractDocument, contractParticulars, uponMySignature, urgeContract } from '../../../api/contract';

    export default {
        name: 'detailsPage',
        data() {
            return {
                caseContent: '',
                data: [],
                list: [],
                beApplied: [],
                fullscreenLoading:false,
                //证据清单列表
                option: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 240,  //操作栏宽度设置
                    column: [
                        {
                            label: '签署人',
                            prop: 'qianshuren'
                        }, {
                            label: '签署手机号',
                            prop: 'signer_mobile'
                        }, {
                            label: '签署状态',
                            prop: 'sign_desc'
                        }, {
                            label: '签署时间',
                            prop: 'sign_time'
                        }
                    ]
                }
            };
        },
        methods: {
            //预览
            // preview(row) {
            //     const link = document.createElement('a'); //自己创建的a标签
            //     link.href = row.all_url + '?v=' + Math.random();
            //     link.target = '_blank';
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            //     window.URL.revokeObjectURL(row.all_url);
            // },
            downloadEvidence(){
                contractDocument(this.$route.query.id).then(res=>{
                    window.open(res.data.fileDownloadUrl, "_blank");
                })
            },
            //签署
            signBtn(row){
                this.fullscreenLoading=true
                uponMySignature(row.id).then(res=>{
                    if (res.code==200){
                        this.fullscreenLoading=false
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.sign_url+'?v='+Math.random();
                        // link.target="_blank"
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.sign_url);
                    }else {
                        this.fullscreenLoading=false
                        this.$message.error(res.msg)
                    }
                })
            },
            // 催办
            urgeBtn(row){
                this.$confirm('请确认是否催办', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    urgeContract({signer_list_id:row.id}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            }
        },
        created() {
            contractParticulars(this.$route.query.id).then(res=>{
                if (res.code==200){
                    this.caseContent=res.data
                    this.data=res.data.signers
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    p {
        flex-shrink: 0
    }

    .dealWithBox {
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }

    p {
        color: #9f9fa2;
        margin-right: 10px;
    }

    span {
        color: #535354;
    }

    .deatlisName > h4 {
        color: #3b63f6;
        width: 100px;
        text-align: center;
        margin-bottom: 10px;
    }

    .deatlisName > p {
        width: 100px;
    }

    /*标题下边内容*/
    .deatlisContent {
        padding: 20px 10px;
    }

    .caseStatus,
    .caseNo,
    .registerTime{
        display: flex;
        width: 30%;
        align-items: flex-end;
    }

    .caseStatusBox {
        display: flex;
        padding: 10px 0px;
    }
    /*申请人*/

    .reasonBox{
        display: flex;
        padding: 10px 0px;
    }

    .reason,
    .contractType,
    .money{
        display: flex;
        width: 30%;
        align-items: flex-end;
    }

    .customize {
        margin-top: 30px;
        background-color: #3b63f6;
        color: #FFFFFF;
    }
    .View{
        background-color: #3e62f6;
        color: #fff;
    }

</style>
